/**
 * EP 争议 — GET /api/admin/ep/orders?status=disputed + 取消并退款（与强制取消同接口）。
 */
import { EpOrdersPage } from './EpOrdersPage';

export function EpDisputesPage() {
  return <EpOrdersPage mode="disputes" />;
}
